import { withTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import warning from "./../../../../../src/assets/img/global/confirmModal/warning.svg";
import { compose } from "redux";
import React, { PureComponent } from "react";
import "./ConfirmClaimModalForm.scss";
import { Form } from "react-final-form";
import PropTypes from "prop-types";
import { Field } from "react-final-form";
import BMXTextField from "../../../../Components/Inputs/BMXTextField/BMXTextField";

class ConfirmServiceClaimModalForm extends PureComponent {
  static defaultProps = {};

  render() {
    const {
      t,
      onSubmit,
      formName,
      mainText,
      contentText,
      initialValues,
      isError,
      setIsError,
      setIsLoading,
      isLoading,
      isCustomFaVatNumber,
    } = this.props;

    const innerOnSubmit = async (e) => {
      setIsLoading(true);
      setIsError(await onSubmit(e));
      setIsLoading(false);
    };

    const validate = (values) => {
      const errors = {};

      // if (!values.claimNumber) {
      //   errors.claimNumber = t("global:service.errors.claimNumber");
      // }

      return errors;
    };

    return (
      <Form
        initialValues={initialValues}
        onSubmit={innerOnSubmit}
        validate={validate}
      >
        {(formProps) => (
          <form
            onSubmit={formProps.handleSubmit}
            className="ConfirmClaimModalForm"
            id={formName}
          >
            <Row>
              <Col className="d-flex justify-content-center mt-5 mb-2" md={12}>
                <img className="img" src={warning} alt="Warning logo" />
              </Col>
            </Row>

            <>
              <Row>
                <Col className="title mt-3A mt-2" md={12}>
                  {t(mainText)}
                </Col>
              </Row>
              <Row>
                <Col className="content mb-2" md={12}>
                  {t(contentText)}
                </Col>
              </Row>
            </>

            <>
              <Row className="mb-4">
                <Col xs={12}>
                  <Field
                    name="claimNumber"
                    label={`${t("global:service.claimNumber")}`}
                    component={BMXTextField}
                    data-cy="claimNumber"
                  />
                </Col>
              </Row>
            </>
          </form>
        )}
      </Form>
    );
  }
}

ConfirmServiceClaimModalForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  mainText: PropTypes.string,
  contentText: PropTypes.string,
};

ConfirmServiceClaimModalForm.defaultProps = {
  onSubmit: () => {},
  mainText: "global:confirmModal.delete",
  contentText: "global:confirmModal.confirmDeleteText",
};

export default compose(withTranslation())(ConfirmServiceClaimModalForm);
